export class TagArquivo {
  idTagArquivo: number;
  nome: string;
  idCategoriaArquivo: number;
}
